export default Object.freeze({
  USER_REGISTERED: 'user_registered',
  USER_LOGIN: 'user_login',

  CONTEXT_OPENED: 'context_opened',
  DESIGN_MUTATED: 'design_mutated',
});
